module.exports = __webpack_public_path__ + "img/heart-icon.d270e2dd.png";